export const axodusModuleRegistry = [
  {
    id: 'dashboard',
    name: 'Protocol Overview',
    route: '/dashboard',
    primaryScope: 'protocol',
    supportedScopes: ['protocol', 'user', 'tenant', 'operator'],
    maturity: 'prototype',
    walletAware: true,
    tenantAware: true,
    governanceAware: true,
    acsAware: true,
  },
  {
    id: 'governance',
    name: 'Governance',
    route: '/governance',
    primaryScope: 'tenant',
    supportedScopes: ['protocol', 'user', 'tenant', 'operator'],
    maturity: 'prototype',
    walletAware: true,
    tenantAware: true,
    governanceAware: true,
    acsAware: true,
  },
  {
    id: 'business',
    name: 'Business',
    route: '/business',
    primaryScope: 'operator',
    supportedScopes: ['protocol', 'user', 'tenant', 'operator'],
    maturity: 'prototype',
    walletAware: false,
    tenantAware: true,
    governanceAware: true,
    acsAware: true,
  },
  {
    id: 'marketplace',
    name: 'Marketplace',
    route: '/marketplace',
    primaryScope: 'tenant',
    supportedScopes: ['protocol', 'user', 'tenant', 'operator'],
    maturity: 'prototype',
    walletAware: true,
    tenantAware: true,
    governanceAware: true,
    acsAware: true,
  },
  {
    id: 'academy',
    name: 'Academy',
    route: '/academy',
    primaryScope: 'user',
    supportedScopes: ['protocol', 'user', 'tenant', 'operator'],
    maturity: 'prototype',
    walletAware: true,
    tenantAware: true,
    governanceAware: true,
    acsAware: true,
  },
  {
    id: 'defi',
    name: 'Treasury & Defi',
    route: '/defi',
    primaryScope: 'protocol',
    supportedScopes: ['protocol', 'tenant', 'operator'],
    maturity: 'mock',
    walletAware: false,
    tenantAware: true,
    governanceAware: true,
    acsAware: false,
  },
  {
    id: 'acs',
    name: 'ACS',
    route: '/acs',
    primaryScope: 'operator',
    supportedScopes: ['protocol', 'tenant', 'operator'],
    maturity: 'prototype',
    walletAware: false,
    tenantAware: true,
    governanceAware: true,
    acsAware: true,
  },
];

export function getModuleMeta(moduleId) {
  return axodusModuleRegistry.find((module) => module.id === moduleId);
}

export function getModulesByScope(scope) {
  return axodusModuleRegistry.filter((module) => module.supportedScopes.includes(scope));
}
